import type { Project } from '../types';

/**
 * Reads project assignment across the v1/v2 schema window. v1 stored worker
 * IDs in `assignedCrewIds` (misnamed); v2 uses `assignedUserIds`. After
 * cleanup, only the new field exists and this helper becomes a passthrough.
 *
 * **Respaldo, NO unión** — y se probó la unión antes de descartarla.
 *
 * Comparando las dos reglas, la única diferencia de comportamiento es esta:
 *
 *     canónica=[],  heredada=[a,b]  →  respaldo [a,b]   unión [a,b]   igual
 *     canónica=[a], heredada=[a,b]  →  respaldo [a]     unión [a,b]   ← única
 *     canónica=[a], heredada=[]     →  respaldo [a]     unión [a]     igual
 *
 * Es decir: unir NO arregla el caso de "quitar a todos" —con la canónica
 * vacía las dos reglas devuelven la cuadrilla heredada entera— y lo único que
 * añade es volver a meter a gente que la columna canónica ya no lista.
 *
 * Esta función va a decidir en qué obras puede fichar cada quien. Para una
 * autorización, equivocarse abriendo es peor que equivocarse cerrando, y
 * `assignedCrewIds` está marcada `@deprecated` en types.ts: hacerla
 * autoritativa iría en contra del final al que apunta el esquema.
 *
 * Comprobado en producción (59 obras): CERO obras donde la heredada tenga a
 * alguien que la canónica no tenga. Las dos columnas nunca han discrepado,
 * así que unir tampoco compraba nada.
 *
 * Lo que de verdad evita resucitar a nadie es escribir SIEMPRE las dos
 * columnas a la vez, que es lo que hace ProjectOverview al guardar la
 * cuadrilla. Si algún día una escritura toca solo una, el fallo está ahí, no
 * aquí.
 */
export function getAssignedUserIds(project: Project): string[] {
    const canonicos = project.assignedUserIds ?? [];
    if (canonicos.length > 0) return [...canonicos];
    return [...(project.assignedCrewIds ?? [])];
}
